import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import {
  RegisterEntityStepFormSchema,
  RegisterEntityStepMutation,
} from './RegisterEntityStepForm.types';
import { getRegisterEntityStepForm } from './RegisterEntityStepForm.schema';
import { useMutation, useQueryClient } from 'react-query';
import { REGISTER_SIGN_UP_QUERY_KEY, registerEntityQuery } from './RegisterEntityStepForm.query';
import { Controller } from 'react-hook-form';
import { registerEntityStepData } from './RegisterEntityStepForm.data';
import Input from '../../../../../commons/Input/Input';
import { useAddressAutocomplete } from '../../../../../../hooks/fetchers/useAddressAutocomplete/useAddressAutocomplete';
import { ChangeEvent, useState } from 'react';
import SearchInput from '../../../../../commons/SearchInput/SearchInput';
import { AddressSuggestion } from '../../../../../../types/models/address/address.types';
import departements from '../../../../../../assets/json/departements-region.json';
import Button from '../../../../../../components/designSystem/Button/Button';
import { ButtonSize } from '../../../../../../components/designSystem/Button/Button.types';
import { useDispatch } from 'react-redux';
import { setProfile } from '../../../../../../store/authentication/authenticationActions/authenticationActions';
import { useCookies } from 'react-cookie';
import { useCurrentUser } from '../../../../../../hooks/useCurrentUser/useCurrentUser';
import { User } from '../../../../../../types/models/user/user.types';
import { getStepIdFromPUBStep } from '../../../../../../utils/helpers/user/getStep';
import { RegisterStepsList } from '../../RegisterSteps.types';
import { api } from '../../../../../../utils/api/api';
import moment from 'moment';
import RegisterStepButton from '../../../../../commons/RegisterStepButton/RegisterStepButton';
// import { useDropzone } from 'react-dropzone';

export default () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  const [, setCookie, removeCookie] = useCookies(['token']);

  const currentUser = useCurrentUser() as User;

  const [searchInputValue, setSearchInputValue] = useState<string>('');

  // const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
  //   multiple: false,
  //   accept: {
  //     // 'image/*': ['.png', '.jpg', '.jpeg'],
  //     'application/pdf': ['.pdf'],
  //   },
  // });

  const { data } = useAddressAutocomplete(searchInputValue);

  const formProps = useForm<RegisterEntityStepFormSchema>({
    resolver: yupResolver(getRegisterEntityStepForm),
    mode: 'onChange',
    reValidateMode: 'onChange',
  });

  const {
    handleSubmit,
    control,
    setValue,
    formState: { isValid, errors },
  } = formProps;

  const { mutate } = useMutation<
    Awaited<ReturnType<RegisterEntityStepMutation>>,
    Error,
    RegisterEntityStepFormSchema
  >((data) => registerEntityQuery(data), {
    mutationKey: REGISTER_SIGN_UP_QUERY_KEY,
    onMutate: () => queryClient.cancelMutations(),
    onSuccess: async ({ accessToken }) => {
      api.setHeader('authorization', `Bearer ${accessToken}`);
      removeCookie('token', { path: '/' });
      setCookie('token', accessToken, { expires: moment().add(60, 'minutes').toDate(), path: '/' });
      setProfile({ ...currentUser, id_step: getStepIdFromPUBStep(RegisterStepsList.Entity) })(
        dispatch
      );
      // navigate('/register/PUB/step/user')
    },
    onError: async (error) => {
      // if (error.name === 'Invalid token') {
      //   alert(error.message)
      // }
      alert(error.message);
    },
  });

  const onAddressChange = (
    e: ChangeEvent<HTMLInputElement>,
    onChange: (e: ChangeEvent<HTMLInputElement>) => void
  ) => {
    const value = e.target.value;
    onChange(e);
    setSearchInputValue(value);
  };

  const handleSelectedSuggestion = (suggestion: AddressSuggestion) => {
    setSearchInputValue('');
    setValue('address', suggestion.address);
    setValue('city', suggestion.city);
    setValue('postalCode', suggestion.postalCode);
    setValue('department', suggestion.department);
    setValue(
      'region',
      departements.find((res) => res.num_dep.toString() == suggestion.department_code)
        ?.region_name || ''
    );
    if (suggestion.coordinates) {
      setValue('latitude', suggestion.coordinates.latitude)
      setValue('longitude', suggestion.coordinates.longitude)
    }
  };

  const onSubmit = handleSubmit((data) => mutate(data));

  return (
    <form className="form">
      {/* <div {...getRootProps({ className: 'dropzone register__dropzone' })}>
        <input {...getInputProps()} />
        <p>Glissez votre logo ici</p>
        {acceptedFiles.length > 0 && <span>{acceptedFiles[0].name}</span>}
      </div> */}
      {registerEntityStepData.map((row, rowIndex) => (
        <div key={rowIndex} className="form__row">
          {row.map(({ name, placeholder, label, type, ...props }, inputIndex) => (
            <Controller
              key={inputIndex}
              name={name}
              render={({ field: { onChange, value } }) =>
                name === 'address' ? (
                  <SearchInput
                    suggestions={data}
                    placeholder={placeholder || ''}
                    type={type}
                    onChange={(e) => onAddressChange(e, onChange)}
                    error={errors[name]?.message as string}
                    {...{ name, value, label, handleSelectedSuggestion }}
                    {...props}
                  />
                ) : (
                  <Input
                    placeholder={placeholder || ''}
                    type={type}
                    disabled={Boolean(
                      ['department', 'region', 'city', 'postalCode'].includes(name)
                    )}
                    error={errors[name]?.message as string}
                    {...{ name, onChange, value, label }}
                    {...props}
                  />
                )
              }
              {...{ control }}
            />
          ))}
        </div>
      ))}
      <RegisterStepButton />
      <Button
        style={{ alignSelf: 'unset' }}
        onClick={(e) => {
          e.preventDefault();
          onSubmit();
        }}
        size={ButtonSize.Large}
        disabled={!isValid}>
        Valider
      </Button>
    </form>
  );
};
